import React from 'react';
import './Machinefact.css';


// Images import
import Machine1 from '../../imgs/Machinefa1.webp';
import Machine2 from '../../imgs/Machinefa2.webp';
import Machine3 from '../../imgs/Machinefa3.webp';
import Machine4 from '../../imgs/Machinefa4.webp';


const cards = [
  { id: 1, img: Machine1 },
  { id: 2, img: Machine2 },
  { id: 3, img: Machine3 },
  { id: 4, img: Machine4 },
];

function Machinefact() {
  return (
    <div className="container">
      {cards.map((Machine) => (
        <div className="Facto" key={Machine.id}>
          <img src={Machine.img} alt={Machine.title} />
        </div>
      ))}
    </div>
  );
}

export default Machinefact;
